import Vue from "vue";
// import fb from "./fb";

// let appReady = false;
let browser = {
  lng: "",
  country: ""
};

// offset en milisegundos
// let today = new Date();
// let msOffset = today.getTimezoneOffset() * 60 * 1000;

// tiempo del servidor en milisegundos
// let realTime = fb.firebase_.firestore.Timestamp.now().seconds * 1000;
// let realTime = new Date() - msOffset;

let timeStamp = function() {
  let dd = new Date();
  return Math.round(dd.getTime() / 1000);
};

let fnDate = function(f) {
  f = f instanceof Date ? f : new Date();
  let max = new Date(f.getFullYear(), f.getMonth() + 1, 0); // ultimo dia del mes
  let min = new Date(f.getFullYear(), f.getMonth(), 1); // primer dia de este mes
  let ultimoDia = new Date(f.getFullYear(), f.getMonth(), 0);
  let anio = f.getFullYear();
  let mes = f.getMonth() + 1;
  let dia = f.getDate();
  let m = mes < 10 ? "0" + mes : mes;
  let d = dia < 10 ? "0" + dia : dia;
  return {
    fecha: f,
    iso: anio + "-" + m + "-" + d,
    anio: anio,
    mes: mes,
    dia: dia,
    diaSem: f.getDay(),
    diasMes: ultimoDia.getDate(),
    max: max.toISOString().slice(0, 10),
    min: min.toISOString().slice(0, 10)
  };
};

// anio, mes, dia. mes 1-12
let fnAnioMesDia = function(a, m, d) {
  let dd = new Date(a, m - 1, d, 0, 0, 0, 0);
  return dd instanceof Date ? fnDate(dd) : false;
};

// string "2020-12-31"
let fnIso = function(isoDate) {
  let arr = isoDate.split("-");
  let dd = new Date(arr[0], arr[1] - 1, arr[2], 0, 0, 0, 0);
  return dd instanceof Date ? fnDate(dd) : false;
};

let fnTime = function(time) {
  let dd = new Date(time);
  return fnDate(dd);
};

var appStart = false;
var toAfterStart = false;

const infoo = {
  appStart: appStart,
  toAfterStart: toAfterStart,
  browser: browser,
  hoy: fnDate(),
  date: fnDate,
  fechaAMD: fnAnioMesDia,
  fechaIso: fnIso,
  fechaTime: fnTime,
  timeStamp: timeStamp
};

Vue.use({
  install(Vue) {
    let lng = window.navigator.language || navigator.browserLanguage;
    browser.lng = lng.substr(0, 2).toLowerCase();
    browser.country = lng.substr(3, 4).toLowerCase();

    Vue.prototype.$infoo = infoo;
  }
});

export default infoo;
